import React from "react";
import { StyledButton } from "@aureskonnect/react-ui";

export function CustomMainColorButton(props: any) {
    return <StyledButton {...props} />;
}
